import { render, staticRenderFns } from "./UsuarioNovo.vue?vue&type=template&id=0212c6f4"
import script from "./UsuarioNovo.vue?vue&type=script&lang=js"
export * from "./UsuarioNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports